import { Component, Input } from '@angular/core';
import { Staff } from '../../models/staff.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StaffService } from '../../services/staff.service';
import { UtilService } from '../../services/util.service';
import { BranchService } from '../../services/branch.service';

@Component({
  selector: 'app-staff-modal',
  templateUrl: './staff-modal.component.html',
  styleUrl: './staff-modal.component.scss'
})
export class StaffModalComponent {

  @Input() idBranch: string = '';
  @Input() staff?: Staff;

  public dataForm: DataFormModel = {
    names: {
      value: '',
      type: 'text',
      label: 'Nombre(s)',
      requiredMessage: 'Por favor, ingresa el nombre',
      required: true,
      validators: [Validators.required]
    },
    paternalSurname: {
      value: '',
      type: 'text',
      label: 'Apellido paterno',
      requiredMessage: 'Por favor, ingresa el apellido paterno',
      required: true,
      validators: [Validators.required]
    },
    maternalSurname: {
      value: '',
      type: 'text',
      label: 'Apellido materno',
      requiredMessage: 'Por favor, ingresa el apellido materno',
      required: true,
      validators: [Validators.required]
    }
  };

  public formStaff!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public staffService: StaffService,
    public utilService: UtilService,
    public branchService: BranchService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formStaff.controls;
  }

  async loadData() {
    this.loading = true;

    if (this.staff) {
      this.dataForm = {
        ...this.dataForm
      };

      for (let key of Object.keys(this.dataForm)) {
        if (key in this.staff) {
          const standardKey = key as keyof typeof this.staff;
          this.dataForm[key].value = this.staff[standardKey]!;
        }
      }
    }

    this.formStaff = this.utilService.buildForm(this.dataForm);
    this.loading = false;
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formStaff.invalid) {
      return;
    }

    if (this.staff) {
      await this.update();
    } else {
      await this.create();
    }
  }

  async create() {
    const flag = await this.staffService.create(
      this.idBranch,
      this.formStaff.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }
      this.activeModal.close();
    }
  }

  async update() {
    this.formStaff.value.idEmployee = this.staff!.idEmployee;
    this.formStaff.value.idBranch = this.staff!.idBranch;

    const flag = await this.staffService.update(
      this.formStaff.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }
      this.activeModal.close();
    }
  }

}
